<template>
    <div id="container" class="container">
        <myheader2></myheader2>
        <div class="main-page-outer min-width">
            <div class="mx1360 main-count2 flex-r">
                <div class="left-cont">
                    <centerNavBar name="会员服务"></centerNavBar>
                </div>
                <div class="right-cont">
                    <div class="box-outer">
                        <div class="box-header">选择适合您的套餐：</div>
                        <div class="b-bottom">
                            <div class="table-box">
                                <div class="thead">
                                    <div class="td">VIP套餐数</div>
                                    <div class="td">备案作品数</div>
                                    <div class="td">服务价格</div>
                                    <div class="td">加入方式</div>
                                </div>
                                <div class="tbody">
                                    <div class="tr" v-for="v,k in list" :key="v.type_id">
                                        <div class="td flex-r-c-c">
                                            <div class="icon-box">
                                                <!-- <img v-if="v.id==1" class="icon-img" src="../../../static/vip-pic1.png" alt=""> -->
												<img v-if="v.type_id==2" class="icon-img" src="../../../static/vip-pic1.png" alt="">
												<img v-if="v.type_id==3" class="icon-img" src="../../../static/vip-pic3.png" alt="">
												<img v-if="v.type_id==4" class="icon-img" src="../../../static/vip-pic2.png" alt="">
                                            </div>
                                            <div class="level-text">{{v.level_name}}</div>
                                        </div>
                                        <div class="td ba-td">
                                            <div class="ba-text"><span>可备案作品数为</span><span class="gr-t">{{v.goods_num}}个/年</span>
                                            </div>
                                        </div>
                                        <div class="td">
                                            <div class="price-text">
                                                <span class="small-t">￥</span><span class="pr-num">{{v.money}}</span><span
                                                    class="small-t2">/年</span>
                                            </div>
                                        </div>
                                        <div class="td">
                                            <div @click="openDialog(k,v)" class="btn-box cur">
                                                立即开通
                                            </div>
                                            <!-- <div class="date-box">
                                                <div class="nm-text"><span>会员权益到期时间：</span><span class="red-t">2026-07-01</span>
                                                </div>
                                            </div> -->
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <openvip ref="vipDialog"></openvip>
        <myfooter2></myfooter2>
    </div>
</template>

<script>
let that;
import ty from "@/utils/ty/ty";
import util from "@/common/util.js"
import openvip from "@/components/openVip/openVip"

export default {
    name: "vipService",
    components: {
        openvip
    },
    data() {
        return {
			list:[],
        }
    },
    created() {
        that = this;
    },
    mounted() {
		this.getlist()
		
    },
    methods: {
        goPage(path) {
            util.tourl(path)
        },
		// getlist(){
		// 	ty.ajax("web/holder/holder-level/index",{}).then((d)=>{
		// 		this.list = d.data.data
		// 	})
		// },
		getlist(){
			ty.ajax("web/order/order/initpay",{}).then((d)=>{
				this.list = d.data.type_list
			})
		},
        openDialog(type_index,v) {
			this.$refs.vipDialog.openvip(type_index,v)
        }
    },
};
</script>

<style lang="scss">
@import '../../style.scss'; //所有页面公用
@import '../../style2.scss'; //所有页面公用
@import './vipService.scss';
</style>